import styled from 'styled-components';
import { mq, getGridSpan, getSpace, getColor } from '../../../stylesheets/tools';

import { QuoteProps } from './quote';

type Props = Pick<QuoteProps, 'color' | 'wide'>;

const StyledQuote = styled.blockquote<Props>`
  display: block;
  margin: 0;
  padding: ${getSpace('m')} 0 ${getSpace('m')} ${getSpace('xs')};
  width: ${getGridSpan('12')};
  float: ${props => (props.wide ? 'none' : 'left')};

  ${mq('m')} {
    padding: ${getSpace('xs')} ${getSpace('m')};
    width: ${props => (props.wide ? getGridSpan('10') : getGridSpan('5', 'spread'))};
  }

  .quote__image {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-bottom: ${getSpace('s')};
    object-fit: cover;

    ${mq('m')} {
      width: 100px;
      height: 100px;
      margin-bottom: ${getSpace('m')};
    }
  }

  .quote__quotation {
    position: relative;
    color: ${props => (props.color ? props.color : props.theme.siteTheme.borderColor)};
  }

  .quote__icon {
    position: absolute;
    top: -30px;
    left: -20px;

    path {
      fill: ${props => (props.color ? props.color : props.theme.siteTheme.borderColor)};
    }

    ${mq('m')} {
      top: -20px;
      left: -30px;
    }
  }

  .quote__author {
    position: relative;
    display: flex;

    ${mq('m')} {
      width: ${props => (props.wide ? getGridSpan('4', 'spread', '10') : '')};
    }

    &:before {
      content: '';
      display: inline-block;
      border-top: 2px solid ${getColor('black')};
      width: 40px;
      height: 14px;
      margin: ${getSpace('12px')} ${getSpace('14px')} 0 0;
    }
  }
`;

export default StyledQuote;
